/* ============================================================
   URL SLUGS
   Category and subcategory names become real URL segments, so
   "Gold Rings" is reachable at /shop/rings/gold-rings and can be
   indexed, linked to and ranked on its own.
   ============================================================ */

/**
 * Turn a display name into a URL-safe slug.
 * "Gold Rings" → "gold-rings", "Jhumkay & Studs" → "jhumkay-studs"
 */
export function slugify(name) {
  return String(name || '')
    .trim()
    .toLowerCase()
    .normalize('NFKD')                 // split accented characters
    .replace(/[\u0300-\u036f]/g, '')   // drop the accent marks
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, '-')       // everything else becomes a dash
    .replace(/^-+|-+$/g, '')           // trim leading/trailing dashes
    .replace(/-{2,}/g, '-');
}

/**
 * Find the original name a slug refers to.
 * Returns null rather than guessing, so a bad URL falls back cleanly.
 *
 * @param {Array<string|{name:string}>} list
 * @param {string} slug
 */
export function findBySlug(list, slug) {
  if (!slug) return null;
  const target = slugify(slug);
  for (const item of list || []) {
    const name = typeof item === 'string' ? item : item?.name;
    if (name && slugify(name) === target) return name;
  }
  return null;
}

/** Canonical shop path for a category / subcategory pair. */
export function shopPath(cat, sub) {
  let path = '/shop';
  if (cat && cat !== 'All') {
    path += '/' + slugify(cat);
    if (sub && sub !== 'All') path += '/' + slugify(sub);
  }
  return path;
}
